import { Component } from '@angular/core';

@Component({
  selector: 'app-login-fail',
  standalone: true,
  imports: [],
  templateUrl: './login-fail.component.html',
  styleUrl: './login-fail.component.css'
})
export class LoginFailComponent {

}
